import { useAuthStore } from "@/store/auth";
import { useAutoSuggestStore } from "@/store/auto-suggest";
import { useCheckoutProStore } from "@/store/checkout-pro";
import { useCheckoutStore } from "@/store/checkout";
import { useClientStore } from "@/store/client";
import { useContextStore } from "@/store/context";
import { useDatalayerStore } from "@/store/datalayer";
import { useListeDeCoursesStore } from "@/store/liste-de-courses";
import { useMagasinStore } from "@/store/magasin";
import { useMenuStore } from "@/store/menu";
import { useNotificationsStore } from "@/store/notifications";
import { usePanachagesStore } from "@/store/panachages";
import { usePanierStore } from "@/store/panier";
import { useProductSearchStore } from "@/store/product-search";
import { useProductsStore } from "@/store/products";
import { useProduitsSimilairesStore } from "@/store/produits-similaires";
export default defineNuxtPlugin(({ $pinia, $apiDrive, $partenairesEvents, $apiServerCacheRedis }) => {
  let $req = null;
  let $res = null;
  let $config = null;
  if (process.server) {
    $req = useRequestEvent().node.req;
    $res = useRequestEvent().node.res;
    $config = useRuntimeConfig();
  } else {
    $config = {
      public: useRuntimeConfig().public
    };
  }
  $pinia.use(() => ({ $apiDrive, $partenairesEvents, $apiServerCacheRedis, $config, $ssrReq: $req, $ssrRes: $res, $ssrQuery: useRoute().query }));
  useAuthStore();
  useCheckoutProStore();
  useCheckoutStore();
  useClientStore();
  useContextStore();
  useDatalayerStore();
  useListeDeCoursesStore();
  useMagasinStore();
  useMenuStore();
  useNotificationsStore();
  usePanachagesStore();
  usePanierStore();
  useProductSearchStore();
  useProductsStore();
  useAutoSuggestStore();
  useProduitsSimilairesStore();
})